import FeatureAdvancedView from './FeatureAdvancedView'

export default FeatureAdvancedView
